import { SectionType } from '@common/models/sections';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface HomeSliceType {
  sections?: Array<SectionType>;
  isFetching: boolean;
  isFetched: boolean;
  error: string;
}

const homeSlice = createSlice({
  name: 'home',
  initialState: <HomeSliceType>{
    sections: null,
    isFetching: false,
    isFetched: false,
    error: '',
  },
  reducers: {
    fetchHomeRequest(state) {
      state.isFetching = true;
      state.isFetched = false;
      state.sections = null;
      state.error = '';
    },
    fetchHomeSuccess(state, { payload }: PayloadAction<Array<SectionType>>) {
      state.sections = payload;
      state.isFetching = false;
      state.isFetched = true;
    },
    fetchHomeFailure(state, { payload }: PayloadAction<string>) {
      state.error = payload;
      state.isFetching = false;
      state.isFetched = true;
    },
  },
});

export const { fetchHomeSuccess, fetchHomeRequest, fetchHomeFailure } = homeSlice.actions;

export default homeSlice.reducer;
